export default __webpack_public_path__ + "static/media/ic_xvs_16.4de54d0d.svg";